import {FC, Fragment} from "react";
import styled from "styled-components";
import {Outlet} from "react-router-dom";
import {useSelector} from "react-redux";
import {getIsShowSecretPage} from "modules/selectors";
import {Footer, Header} from "components";
import {SecretPage} from "./SecretPage";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	width: 100%;
	height: 100%;
	position: relative;
	min-height: 100vh;
	background-color: ${({theme}) => theme.background.card};
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100%;
	flex-grow: 1;
	position: relative;
	background: url(${({theme}) => theme.background.bgImage});
	background-size: cover;
`;

export const Layout: FC = () => {
	const isShowSecretPage = useSelector(getIsShowSecretPage);

	return (
		<Wrapper>
			{isShowSecretPage ? (
				<Container>
					<SecretPage />
				</Container>
			) : (
				<Fragment>
					<Header />

					<Container>
						<Outlet />
					</Container>
				</Fragment>
			)}

			<Footer />
		</Wrapper>
	);
};
